import { IHeaderTrackingData } from '@patsnap/synapse_common_interface'
import { transObj2CookieString } from '@patsnap/synapse_common_utils'
import { AxiosInstance } from 'axios'
import { trackingEventSource, trackingPage } from 'pharmsnapMF_shared/utils'
import router from '../router'

const X_TRACKING = 'x-tracking'

function getRouteNameByPathName(pathname: string) {
  const curRoute = router.match(pathname)
  return curRoute ? curRoute.meta?.trackingRouteName || curRoute.name : ''
}
function extractThirdLevelDomain(url: string) {
  // 使用正则表达式匹配URL的域名部分，支持http和https
  const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+)\.([a-zA-Z0-9-]+)\.([a-zA-Z0-9-]+)/
  const match = url.match(regex)

  if (match) {
    return match[2] // 返回三级域名
  } else {
    return null // 如果URL不符合预期格式
  }
}
function isPatsnapDomain(url: string) {
  const _url = new URL(url)
  if (_url.hostname.includes('zhihuiya.com') || _url.hostname.includes('patsnap.com')) {
    return true
  }
  return false
}
// https://confluence.zhihuiya.com/display/PBC/CB+20250116+UAT #7
function extractPatsnapProductNameByUrl(url: string) {
  if (!isPatsnapDomain(url)) {
    return ''
  }
  return extractThirdLevelDomain(url)?.toLocaleLowerCase() || ''
}
const { referrer } = document

/**
 * 接口埋点拦截器
 * @param axiosIns axios实例
 */
export function interceptAxiosWithTracking(axiosIns: AxiosInstance) {
  axiosIns.interceptors.request.use((config) => {
    const prePageName = trackingPage().getPrePageName()
    const referrerPageName = referrer ? getRouteNameByPathName(new URL(referrer).pathname) || extractPatsnapProductNameByUrl(referrer) : ''
    const fromPage = prePageName || referrerPageName
    let trigger_point = ''
    if (config.trackingName) {
      trigger_point = trackingEventSource().getTrackingEventSourceByConsumer(config.trackingName)?.trigger_point || ''
    }

    const trackingData: IHeaderTrackingData = {
      from_page: fromPage || '',
      from_page_url: trackingPage().getPrePageUrl() || referrer || '',
      current_page: trackingPage().getCurrentPageName() || '',
      current_page_url: trackingPage().getCurrentPageUrl() || '',
      trigger_point: trigger_point || '',
    }

    const tracking = transObj2CookieString(trackingData)

    config.headers = {
      ...config.headers,
      ...(tracking
        ? {
            [X_TRACKING]: tracking,
          }
        : {}),
    }
    return config
  })
}
